import { AmbassadorContentSecond } from '../../../enums';
import React from 'react';
import LazyLoad from 'react-lazyload';

export const AmbassadorPositiveVisionOrganism = () => {
  return (
    <div className="box-border block mt-10">
      <div className="block flex flex-col lg:flex-row items-end lg:items-start pt-0 w-10/12 lg:w-8/12 mx-auto box-border">
        <div className="w-full lg:w-75 mr-0 lg:mr-1/20 mt-0 lg:mt-10">
          <h2 className="inline-block text-large lg:text-3xl leading-10 text-left lg:text-right">
            Everything we do starts with&nbsp;
            <span className="underline inline lg:inline-block">
              {AmbassadorContentSecond.SECOND_TITLE}
            </span>
          </h2>

          <p className="text-lg mt-4 flex w-full justify-self-start  lg:justify-end">
            <span className="w-full lg:w-36 block text-left lg:text-right inline-block">
              We&apos;re looking for ambassadors who:
            </span>
          </p>
        </div>
        <div className="w-full lg:w-3/5">
          <div className=" text-lg">
            {AmbassadorContentSecond.SECOND_ITEMS.map(
              (item: any, index: number) => (
                <div
                  className="w-full flex flex-row mt-6 lg:mt-8 items-center justify-end"
                  key={index}
                >
                  <div className="w-1/4 flex flex-row justify-center ">
                    <LazyLoad offset={100}>
                      <img
                        src={`/images/icons/doctor-ambassador/listing/${item.image}`}
                      />
                    </LazyLoad>
                  </div>
                  <div className="w-18/25 ml-3">
                    <p className="font-semibold text-base leading-5.5">
                      {item.title}
                    </p>
                    <p className="text-lg leading-5.5 mt-1">
                      {item.description}
                    </p>
                  </div>
                </div>
              )
            )}
            <div className="w-full flex-row mt-8  justify-end hidden lg:flex">
              <div className="w-1/5 flex flex-row justify-center">
                <LazyLoad offset={100}>
                  <img
                    src={`/images/icons/doctor-ambassador/listing/as-waldo-arrow.svg`}
                  />
                </LazyLoad>
              </div>
              <div className="w-18/25 ml-3">
                <p className="font-semibold text-base leading-5.5">
                  {AmbassadorContentSecond.SECOND_CONTENT}
                </p>
              </div>
            </div>
          </div>
          <div className="text-lg text-waldo-blue font-medium leading-5.5 mt-8 block lg:hidden">
            {AmbassadorContentSecond.SECOND_CONTENT}
          </div>
        </div>
      </div>
    </div>
  );
};
